import { render } from "./General.vue?vue&type=template&id=6f6467c1"
import script from "./General.vue?vue&type=script&lang=js"
export * from "./General.vue?vue&type=script&lang=js"
script.render = render

export default script